<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-curt-card" min-width="240">
    <v-row class="com-pc-card-header" v-show="pcPanelMode">
      <div class="com-pc-card-title">
        {{ text.title }} {{ tmSwStageList.curt.obsTime }}
      </div>
    </v-row>
    <v-row
      class="com-pc-card-contents justify-space-around flex-nowrap flex-column"
      no-gutters
    >
      <v-row no-gutters class="justify-center">
        <v-col>
          <v-sheet
            outlined
            class="tm-pc-current-stg-data-box"
            min-width="160"
            max-width="200"
            width="70%"
          >
            <v-row no-gutters>
              <div
                class="tm-pc-current-label tm-pc-stg-fld-color"
                :stg-fld-color="fldColor"
                :label-height="labelHeight"
              >
                {{ text.category }}
              </div>
            </v-row>
            <v-row
              no-gutters
              v-show="showSwStgOvlvlNm(tmSwStageList.curt.swstgOvlvl)"
            >
              <div
                class="tm-pc-current-ovlvl-label tm-pc-stg-fld-color"
                :stg-fld-color="fldColor"
              >
                {{ stgOvlvlNm }}
              </div>
            </v-row>
            <v-divider></v-divider>
            <v-row class="card" no-gutters justify="center">
              <span>{{ tmSwStageList.curt.stgHght }}</span>
              <span>{{ text.stgUnit }}</span>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-if="tmSwStageList.curt.isAbnrml"
                    v-on="on"
                    class="icon-qmflg"
                  >
                    warning
                  </v-icon>
                </template>
                <span>{{ text.abnormal }}</span>
              </v-tooltip>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
      <v-row no-gutters class="justify-center">
        <div class="annotation-small" v-if="!pcPanelMode">
          {{ swStgMsg.annotation1 }} <br />
          {{ swStgMsg.annotation2 }}
        </div>
        <!-- <v-row class="d-flex justify-center" no-gutters> -->
        <div class="annotation-large" v-if="pcPanelMode">
          {{ swStgMsg.annotation1 }} <br />
          {{ swStgMsg.annotation2 }}
        </div>
        <!-- </v-row> -->
      </v-row>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]危機管理 最新観測値カード
 * TmSwStageCurt.vue
 * @author ILUKE
 */

import mixin from "./../../lib/mixin.js";
export default {
  name: "tm-sw-stage-curt",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "最新観測値",
        category: "堤防天端からの高さ",
        stgUnit: "m",
        abnormal: "異常のおそれあり",
      },
      fldColor: "normal",
      labelHeight: "other",
      stgOvlvlNm: "",
    };
  },
  computed: {
    /**
     * 危機管理情報 取得
     */
    tmSwStageList: {
      get() {
        return this.$store.state.Swin.selectedSw;
      },
    },
    /**
     * フレームの拡大・縮小判定用
     */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /**
     * 注記文言
     */
    swStgMsg: {
      get() {
        return this.$store.state.app.config.messageConfig.swStg;
      },
    },
  },
  mounted() {
    /** 水位超過 着色 */
    const crntfld = this.tmSwStageList.curt;
    this.fldColor = this.setFloodColor(crntfld.swstgOvlvl, crntfld.swstgCcd);
    this.labelHeight = this.setLablHeight(crntfld.swstgOvlvl);
    this.stgOvlvlNm = this.getSwStgOvlvlNm(crntfld.swstgOvlvl);
  },
  methods: {
    /** 水位超過 着色 */
    setFloodColor(ovlvl, ccd) {
      if (ovlvl === 90) {
        // 氾濫開始水位超過(危機管理)
        return "occurrence";
      } else if (ovlvl === 80 || ovlvl === 70) {
        // 氾濫危険水位超過
        return "danger";
      } else if (ovlvl === 60 || ovlvl === 50) {
        // 危険水位超過(危機管理)
        return "refuge";
      } else if (ovlvl === 40 || ovlvl === 30 || ovlvl === 20) {
        // 観測開始水位超過(危機管理)
        return "caution";
      } else if (ovlvl === 10) {
        // 水防団待機水位超過
        return "standbyed";
      } else if (ccd === 190 || ccd === 160) {
        // 欠測
        return "missing";
      } else if (ccd === 140) {
        // 閉局
        return "close";
      } else {
        // 平常
        return "normal";
      }
    },
    /** ラベルの高さを設定する */
    setLablHeight(stgOvlvl) {
      if (10 <= stgOvlvl && stgOvlvl <= 90) {
        return "stgOvlvl";
      }
      return "other";
    },
    /** 超過基準水位名を表示するか */
    showSwStgOvlvlNm(stgOvlvl) {
      if (10 <= stgOvlvl && stgOvlvl <= 90) {
        return true;
      }
      return false;
    },
    /**
     * 危機管理水位：超過基準水位名の取得
     */
    getSwStgOvlvlNm(stgOvlvl) {
      if (stgOvlvl === 90) {
        return "氾濫開始水位超過";
      } else if (stgOvlvl === 80) {
        return "危険水位超過";
      } else if (stgOvlvl === 30) {
        return "水位観測中";
      }
      return "";
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
</style>
